<template>
    <div>
        <el-radio-group class="common-el-radio-group" v-model="form.type" @change="searchBannerList()">
            <el-radio-button label="0">大厅Banner</el-radio-button>
            <el-radio-button label="1">发现页Banner</el-radio-button>
            <el-radio-button label="2">发现页主图</el-radio-button>
            <el-radio-button label="4">游戏商城主图</el-radio-button>
            <el-radio-button label="5">竞标赛Banner</el-radio-button>
        </el-radio-group>

        <div>
            <el-button type="primary" @click="show = true">新增</el-button>
            <el-button type="danger" @click="removeSelectionBanners">删除</el-button>
        </div>
        <div class="common-table">
            <el-table
                    v-loading="loading"
                    :data="mttBannerList"
                    :row-key="(row)=>row.id+row.updatedOn"
                    height="100%"
                    @selection-change="selectionChange">
                <el-table-column type="selection"/>
                <el-table-column label="排序" align="center" type="index"/>
                <el-table-column label="产品" align="center">
                    <template slot-scope="scope">
                        {{scope.row.product | productText(productArr)}}
                    </template>
                </el-table-column>
                <el-table-column label="图片" align="center" width="100">
                    <template slot-scope="scope">
                        <preview-picture :src="scope.row.imageUrl| getImage"/>
                    </template>
                </el-table-column>
                <el-table-column label="web地址" width="200" align="center" prop="redirectUrl"/>
                <el-table-column label="语言" align="center">
                    <template slot-scope="scope">
                        {{scope.row.lang |langText (langArr)}}
                    </template>
                </el-table-column>
                <el-table-column label="状态" align="center" width="80">
                    <template slot-scope="scope">
                        {{scope.row.status?'上架':'下架'}}
                    </template>
                </el-table-column>
                <el-table-column label="描述" width="200" align="center" prop="description"/>
                <el-table-column label="创建时间" width="150" align="center" prop="createdOn"/>
                <el-table-column label="最后更新时间" width="150" align="center" prop="updatedOn"/>
                <el-table-column label="操作" align="center" width="150">
                    <template slot-scope="scope">
                        <el-button type="primary" size="mini" @click="editFunc(scope.row)">编辑</el-button>
                        <el-button type="danger" size="mini" @click="removeBanners([scope.row.id])">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <el-pagination
                class="common-el-pagination"
                layout="prev,pager,next,jumper"
                background
                :page-size="20"
                :pager-count="5"
                :total="mttBannerListTotal"
                :current-page="currentPage"
                @current-change="searchBannerList({page:$event})"/>

        <div v-if="show" class="common-popup-bg">
            <div class="common-popup">
                <h3>{{form.id?'编辑':'新增'}}</h3>
                <el-form ref="ruleForm" :model="form" :auto-upload="false">
                    <table class="common-popup-table">
                        <tr>
                            <td class="required">产品：</td>
                            <td>
                                <el-select size="medium" v-model="form.product">
                                    <el-option
                                            v-for="item of productArr"
                                            :key="item.label"
                                            :label="item.label"
                                            :value="item.value"/>
                                </el-select>
                            </td>
                            <td class="required" style="text-align: left" rowspan="3">
                                上传图片:
                                <div class="common-uploadImg">
                                    <input @change="fileChange" type="file" accept="image/*">
                                    <img v-if="form.imageUrl" :src="form.imageUrl" class="avatar">
                                    <i v-else class="el-icon-plus"></i>
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <td class="required">语言：</td>
                            <td>
                                <el-select size="medium" v-model="form.lang">
                                    <el-option
                                            v-for="item of langArr"
                                            :key="item.label"
                                            :label="item.label"
                                            :value="item.value"/>
                                </el-select>
                            </td>
                        </tr>
                        <tr>
                            <td class="required">状态：</td>
                            <td>
                                <el-select size="medium" v-model="form.status">
                                    <el-option
                                            v-for="item of statusArr"
                                            :key="item.label"
                                            :label="item.label"
                                            :value="item.value"/>
                                </el-select>
                            </td>
                        </tr>
                        <tr>
                            <td>web地址：</td>
                            <td colspan="2">
                                <el-input size="medium" v-model="form.redirectUrl"></el-input>
                            </td>
                        </tr>
                        <tr>
                            <td style="vertical-align: top">描述：</td>
                            <td colspan="2">
                                <el-input type="textarea" v-model="form.description" resize="none"/>
                            </td>
                        </tr>
                    </table>
                </el-form>
                <footer>
                    <el-button size="small" @click="close">取消</el-button>
                    <el-button size="small" type="primary" @click="submit()">确定</el-button>
                </footer>
            </div>
        </div>
    </div>
</template>
<script>
    import {mapState, mapActions} from 'vuex'
    import previewPicture from "components/previewPicture";

    export default {
      components: {
        previewPicture
      },
        data() {
            return {
                loading: false,
                currentPage: 1,
                show: false,
                productArr: [
                    {
                        label: 'ALLIN',
                        value: 0
                    }
                ],
                langArr: [{
                    label: '简体中文',
                    value: 'zh_CN'
                }, {
                    label: '繁体中文',
                    value: 'zh_HK'
                }, {
                    label: '英文',
                    value: 'en_US'
                }, {
                    label: '日语',
                    value: 'ja_JP'
                }, {
                    label: '泰语',
                    value: 'th_TH'
                }, {
                    label: '越南语',
                    value: 'vi_VN'
                }, {
                    label: '印地语',
                    value: 'hi_IN'
                }
                ],
                statusArr: [{
                    label: '下架',
                    value: 0
                }, {
                    label: '上架',
                    value: 1
                }],
                form: {
                    type: 0,
                    id: null,
                    product: null,
                    lang: null,
                    status: null,
                    imageUrl: null,
                    redirectUrl: null,
                    description: null
                },
                selectBannerIds: [],// 选中的
                imgFile: null,
            }
        },
        computed: {
            ...mapState('mttBanner', ['mttBannerList', 'mttBannerListTotal', 'uploadBannerUrl'])
        },
        created() {
            this.searchBannerList()
        },
        methods: {
            ...mapActions('other', ['uploadImg']),
            ...mapActions('mttBanner', ['getBannerList', 'addBanner', 'updateBanner', 'deleteBanner']),
            searchBannerList(obj = {}) {
                this.loading = true;
                let params = {
                    type: this.form.type,
                    page: 1
                };
                Object.assign(params, obj);
                this.currentPage = params.page;
                this.getBannerList(params).then(() => {
                    this.loading = false;
                })
            },
            removeBanners(idArr) {
                let text = '确认删除这些图片展示？';
                if (idArr.length === 1) {
                    text = '确认删除当前图片展示？';
                }
                this.$confirm(text, '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.deleteBanner({
                        bannerIds: idArr,
                        type: this.form.type,
                        page: this.currentPage
                    }).then(() => {
                        this.$message.success('删除成功')
                    })
                }).catch(() => {

                });

            },
            removeSelectionBanners() {
                let l = this.selectBannerIds.length;
                if (!l) {
                    this.$message.info('未选择');
                    return
                }
                this.removeBanners(this.selectBannerIds)
            },
            selectionChange(value) {
                this.selectBannerIds = value.map(v => v.id)
            },
            editFunc(info) {
                this.show = true;
                for (let key in this.form) {
                    this.form[key] = info[key]
                }
            },
            close() {
                this.show = false;
                Object.assign(this.form, {
                    id: null,
                    product: null,
                    lang: null,
                    status: null,
                    imageUrl: null,
                    redirectUrl: null,
                    description: null
                })
            },
            async submit() {

                if (this.form.product === null) {
                    this.$message.error('请选择产品');
                    return
                } else if (this.form.lang === null) {
                    this.$message.error('请选择语言');
                    return
                } else if (this.form.status === null) {
                    this.$message.error('请选择状态');
                    return
                } else if (this.form.imageUrl === null) {
                    this.$message.error('请选择图片');
                    return
                }

                if (this.imgFile) {
                    let params = new FormData();

                    params.append('product', this.form.product);
                    params.append('type', this.form.type);
                    params.append('lang', this.form.lang);
                    params.append('file', this.imgFile);
                    this.form.imageUrl = await this.uploadImg(params).then(res => {
                        alert("imgFile============="+this.imgFile)
                        return `${res.data.pic_name}`;//http://${res.data.file_ip}:${res.data.file_port}
                    });
                    this.imgFile = null;
                }
                if (this.form.id) {
                      this.updateBanner({
                        params: this.form,
                        page: this.currentPage
                    }).then(() => {
                        this.$message.success('修改成功');
                        this.close()
                    })
                } else {
                    this.addBanner(this.form).then(() => {
                        this.$message.success('添加成功');
                        this.close()
                    })
                }
            },
            fileChange(e) {
                if (e.target.files.length) {
                    this.imgFile = e.target.files[0];
                    let f = new Blob([this.imgFile]);
                    this.form.imageUrl = URL.createObjectURL(f);
                }
            }
        },
        filters: {
            productText(product, productArr) {
                return productArr.filter(v => {
                    return v.value === product
                })[0].label
            },
            langText(lang, langArr) {
              return langArr.filter(v => {
                    return v.value === lang
                  })[0].label
            }
        }
    }
</script>
<style lang="scss" scoped>
    .common-table{
        min-height: 400px;
    }
</style>
